import { render, staticRenderFns } from "./feedback-list.vue?vue&type=template&id=708b3ae6&scoped=true&"
import script from "./feedback-list.vue?vue&type=script&lang=ts&"
export * from "./feedback-list.vue?vue&type=script&lang=ts&"
import style0 from "./feedback-list.vue?vue&type=style&index=0&id=708b3ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b3ae6",
  null
  
)

export default component.exports